export const handleAuthError = (error: any) => {
  const errorMessage =
    error.response?.data?.error || 'An error occurred during the process.';
  throw new Error(errorMessage);
};
